// extracted by mini-css-extract-plugin
module.exports = {"slide":"Carousel_slide__1-e5i","carousel":"Carousel_carousel__3zd1k","dots":"Carousel_dots__1Qsq7","initial":"Carousel_initial__2cM2B"};